/**
 * Module-level storage for the current user position.
 * This allows the axios client to include position in request headers
 * without needing direct access to the Redux store.
 *
 * Updated by the geolocation middleware when position changes.
 * Read by client-axios to add the User-Coordinates header.
 */

interface Position {
  latitude: number
  longitude: number
  accuracy: number | null
  /** When the browser took the location fix (epoch ms); a staff override has none. */
  timestamp?: number
}

let currentPosition: Position | null = null

/**
 * Staff debug (the Home location panel): stands in for the device's fix on
 * every request. `null` means "pretend there is no fix"; `undefined` means no
 * override. Never persisted — a reload is the real device again.
 */
let positionOverride: Position | null | undefined = undefined

export function setCurrentPosition(position: Position | null): void {
  currentPosition = position
}

export function setPositionOverride(
  position: Position | null | undefined
): void {
  positionOverride = position
}

export function getCurrentPosition(): Position | null {
  return positionOverride === undefined ? currentPosition : positionOverride
}
